import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import PreviewLerros from "../previewStickers/PreviewLerros";
import PreviewOtto from "../previewStickers/PreviewOtto";
import PreviewFussl from "../previewStickers/PreviewFussl";
import PreviewFamilia from "../previewStickers/PreviewFamilia";
import PreviewGalileo from "../previewStickers/PreviewGalileo";
import PreviewTeo from "../previewStickers/PreviewTeo";
import PreviewJimSpencer from "../previewStickers/PreviewJimSpencer";
import PreviewAmg from "../previewStickers/PreviewAmg";

const PreviewModal = ({ show, onHide, data, count = 1, previewData, content }) => {

  const [scale, setScale] = useState(0.7);

  let renderList = [];
  let previous = 0;

  content.forEach((item) => {
    let curr, total;
    let isSlashFormat = false;
  
    if (item.SNO.includes("/")) {
      // Format: "4/8"
      [curr, total] = item.SNO.split("/").map(Number);
      isSlashFormat = true;
    } else if (item.SNO.toLowerCase().includes("of")) {
      // Format: "10 of 26"
      const parts = item.SNO.toLowerCase().split("of").map((s) => s.trim());
      curr = Number(parts[0]);
      total = Number(parts[1]);
    } else {
      console.warn("Unknown SNO format:", item.SNO);
      return;
    }
  
    const repeat = curr - previous;
  
    for (let i = 0; i < repeat; i++) {
      const newNumber = previous + i + 1;
  
      renderList.push({
        ...item,
        SNO: isSlashFormat
          ? `${newNumber}/${total}`   // If format was 4/8 → output 1/8, 2/8 ...
          : `${newNumber} of ${total}` // If format was 10 of 26 → output 1 of 26 ...
      });
    }
  
    previous = curr;
  });



  const previewComponents = {
    LERROS: <PreviewLerros scale={scale} content={content} />,
    MOGSTKOTTO: <PreviewOtto scale={scale} />,
    MOGSTKFUSS: <PreviewFussl scale={scale} />,
    MOGSTKFAMI: <PreviewFamilia scale={scale} />,
    MOGSTKGALI: <PreviewGalileo scale={scale} />,
    MOGSTKTEO: <PreviewTeo scale={scale} />,
    MOGSTKJIMS: <PreviewJimSpencer scale={scale} />,
    MOGSTKAMCB: <PreviewAmg scale={scale} />,
  };

  const PreviewComponent = previewComponents[previewData?.stickerType] || (
    <PreviewLerros scale={scale}  />
  );

  console.log('preview component ?', previewData?.stickerType)


  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      // style={{
      //   '--bs-modal-width': 'calc(100vw - 40px)',
      //   '--bs-modal-max-width': 'calc(100vw - 40px)',
      //   '--bs-modal-height': 'calc(100vh - 40px)',
      //   margin: '20px',
      //   maxWidth: 'calc(100vw - 40px)',
      //   maxHeight: 'calc(100vh - 40px)',
      // }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Barcode Preview</Modal.Title>
        <div
          className="d-flex justify-content-center align-items-center gap-2 "
          style={{
            marginLeft: "50px",
          }}
        >
          <label
            htmlFor="scale-slider"
            className="form-label mb-0"
            style={{ fontSize: "14px" }}
          >
            Scale:
          </label>
          <input
            type="range"
            className="form-range"
            id="scale-slider"
            min="0.3"
            max="1.1"
            step="0.1"
            value={scale}
            onChange={(e) => setScale(parseFloat(e.target.value))}
            style={{
              width: "100px",
              border: "none",
              padding: "5px",
            }}
          />
          <span style={{ fontSize: "12px", minWidth: "30px" }}>
            {Math.round(scale * 100)}%
          </span>
        </div>
      </Modal.Header>
      <Modal.Body
            style={{
              height: '70vh',
              overflow: 'auto',
              padding: '4px',
              backgroundColor: '#f8f9fa',
              // border: '2px solid blue',
              boxShadow: '0 0 10px rgba(0,0,0,0.1)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'start',
            }}
          >
      <div>
        {renderList.map((item, index) => (
          // style={previewData?.stickerType ? {} : { marginBottom: "200px" }}
          <div key={index} style={{marginBottom: '200px'}}>
            {React.cloneElement(PreviewComponent, { content: item })}
          </div>
        ))}
      </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PreviewModal;
